import Vue from "vue"
import { Component } from "vue-property-decorator"
import config from "@/config/config"

@Component({ name: "Layout" })
export default class Layout extends Vue {
  profileLoading = true

  mounted() {
    this.loadProfile()

    if (config.chatScriptUrl.length > 0) {
      this.setupChat()
    }
  }

  setupChat() {
    const scriptTag = document.createElement("script")
    scriptTag.src = config.chatScriptUrl
    scriptTag.type = "text/javascript"
    scriptTag.defer = true

    const firstScriptTag = document.getElementsByTagName("script")[0]
    firstScriptTag.parentNode?.insertBefore(scriptTag, firstScriptTag)
  }

  loadProfile() {
    this.profileLoading = true

    const profileQuery = (this.$route.query.profile as string) || ""

    if (profileQuery !== "") {
      const profileData = JSON.parse(atob(profileQuery) || "null")

      if (
        profileData !== null &&
        profileData.name !== undefined &&
        profileData.company !== undefined &&
        profileData.accountNo !== undefined &&
        profileData.email !== undefined &&
        profileData.phone !== undefined
      ) {
        try {
          window.localStorage.setItem(
            config.profileStorageKey,
            JSON.stringify(profileData),
          )

          const newQuery = { ...this.$route.query }
          delete newQuery.profile
          this.$router.replace({ query: newQuery })
        } catch (error) {
          console.warn("Could not pare profile data: ", error)
        }
      }
    }

    this.profileLoading = false
  }
}
